import { render } from "./AddressInsurers.vue?vue&type=template&id=15fa4e2f"
import script from "./AddressInsurers.vue?vue&type=script&lang=js"
export * from "./AddressInsurers.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__